import { SxProps } from '@mui/material'

export const rootSx: SxProps = {
    position: 'relative',
    minHeight: '100vh',
}
